import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Form, Input, Modal } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import moment from "moment";

import AppService from "./../../../../modules/Appointments/service";
import "./DBBAppointmentDateModal.css";

class DBBAppointmentDateModal extends Component {
  state = {
    contractDate: moment().add(1, "day").startOf("day").hours(8).toDate(),
    isSaving: false,
  };

  handleChangeDate = contractDate => this.setState({ contractDate });

  handleSave = () => {
    const { appointment, onCarUpdate, onError, onClose } = this.props;
    const { contractDate } = this.state;

    if (!contractDate) return;

    this.setState({ isSaving: true });

    AppService.updateDBBAppointmentDate({ appointment_id: appointment.id, dbb_appointment_date: moment(contractDate).format() })
      .then(result => {
        this.setState({ isSaving: false });

        if (!result?.data?.data) return onError("An unknown error occured, please try again");

        onCarUpdate({ ...appointment.car, ...result.data.data });
        onClose();
      })
      .catch(error => {
        this.setState({ isSaving: false });
        const errorMsg = error.response?.data?.errors?.[0] || "Error updating DBB appointment date";
        onError(errorMsg);
        console.warn("Error updating DBB appointment date", error);
      });
  };

  render() {
    const { location, open, onClose, t } = this.props;
    const { contractDate, isSaving } = this.state;

    const tomorrowDate = moment().add(1, "day").toDate();

    return (
      <Modal size="tiny" open={open} onClose={onClose} closeOnDimmerClick={false} className="DBBAppointmentDateModal">
        <Modal.Header>{t("add_dbb_appointment").message || "Add DBB appointment"}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>{t("tyre_location").message || "Tyre location"}</label>
              <Input value={location?.dbb_location_id || ""} readOnly disabled />
            </Form.Field>
            <Form.Field>
              <label>{t("delivery_date").message || "Delivery date"}</label>
              <DatePicker
                selected={contractDate}
                onChange={this.handleChangeDate}
                minDate={tomorrowDate}
                showTimeInput
                showYearDropdown
                showMonthDropdown
                dateFormat="dd-MM-yyyy HH:mm"
                placeholderText={t("choose_contract_date").message || "Choose contract date"}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="grey" onClick={onClose}>
            {t("cancel").message || "Cancel"}
          </Button>
          <Button color="green" onClick={this.handleSave} disabled={isSaving || !contractDate} loading={isSaving}>
            {t("save").message || "Save"}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(DBBAppointmentDateModal);
